import reducer from './reducers';

export { default as cpdCategorysActions } from './actions';
export { default as cpdCategorysSagas } from './sagas';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/areas-of-advice/index.js